import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { PROPERTY_FILTERS } from "components/flexComponents/PropertyFilters/PropertyFilters";
import { UitkButtonToggle } from "uitk-react-button-toggle";
import { withStores } from "src/stores";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";

const ButtonToggleTracked = FlexClickTracker(UitkButtonToggle);

export const ButtonToggle = withStores("propertyFilters")(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, moduleName } = props;

    const onChange = () => {
      propertyFilters.toggleSelection(filterName, option.optionValue!);
    };

    const isSelected = propertyFilters.isSelected(filterName, option.optionValue!);

    return (
      <UitkSpacing margin={{ blockend: "two" }}>
        <ButtonToggleTracked
          id={`${filterName}-${option.optionValue}`}
          labelText={option.label}
          altText={option.selectedLabel}
          moduleName={PROPERTY_FILTERS}
          rfrr={`${moduleName}.${filterName}.${option.optionValue}.${!isSelected}`}
          value={option.optionValue}
          checked={isSelected}
          onChange={onChange}
          data-testid={option.selectedLabel}
        />
      </UitkSpacing>
    );
  })
);
